const MARKET_CATALOG_API_BASE_URL =
  process.env.REACT_APP_MARKET_CATALOG_API_BASE_URL || "";

export async function catalogFetch(path, token, options = {}) {
  if (!MARKET_CATALOG_API_BASE_URL) {
    throw new Error("Missing REACT_APP_MARKET_CATALOG_API_BASE_URL");
  }
  if (!token) {
    throw new Error("Not signed in");
  }

  const response = await fetch(`${MARKET_CATALOG_API_BASE_URL}${path}`, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      ...(options.headers || {}),
    },
  });
  const body = await response.json();
  if (!response.ok) {
    throw new Error(body.error || body.message || "Request failed");
  }
  return body;
}
